import React from 'react';
import ApiInterface from "@/commons/api/ApiInterface";

const MapError = () => {
    ApiInterface.sendToError("mapError");
    // Return a React element, such as JSX
    return <div>Error has been reported.</div>;
}

export default MapError;